import ColorHash from 'color-hash'
import Color from '@/lib/color2'
// import localStorage from 'localStorage'

const darkenColorIndex = {}
const lightenColorIndex = {}
const fadeColorIndex = {}

let colorHashConstructor = ColorHash
if (ColorHash.default) colorHashConstructor = ColorHash.default

export default {
  /*
   * Compute the percieved brightness of a hexadecimal color (#FFFFFF).
   */
  getLuminance (colorHex) {
    const colorRgb = this.hexToRGBLessShit(colorHex)
    return 0.2126 * colorRgb.r + 0.587 * colorRgb.g + 0.114 * colorRgb.b
  },

  isColorDark (colorHex) {
    return (this.getLuminance(colorHex) < 145)
  },

  /*
   * Returns a light color for dark backgrounds and vice versa.
   */
  getTextColor (backgroundHex, lightColor = '#ffffff', darkColor = '#333333') {
    if (this.isColorDark(backgroundHex)) {
      return lightColor
    } else {
      return darkColor
    }
  },

  /*
   * Turn hexadecimal color (#FFFFFF) to a darker and more saturated version.
   * Uses a cache for to not recompute the target color each time this function
   * is called.
   */
  darkenColor(colorHash) {
    if (!darkenColorIndex[colorHash]) {
      darkenColorIndex[colorHash] = Color(colorHash).darken(0.3).saturate(0.6)
    }
    return darkenColorIndex[colorHash]
  },

  /*
   * Convert a string (it can be anything) into a HTML color hash.
   */
  fromString(str, darken = false) {
    let colorHash = new colorHashConstructor({
      lightness: 0.7,
      saturation: 0.8
    })
    if (
      darken ||
      (localStorage && localStorage.getItem('dark-theme') === 'true')
    ) {
      colorHash = new colorHashConstructor({
        lightness: 0.6,
        saturation: 0.8
      })
    }
    return colorHash.hex(str)
  },

  /*
   * This function is needed to convert Shotgun colors to one that are better
   * suited for CGWire skin.
   */
  validationBackgroundColor (task) {
    if (task) {
      if (task.task_status_short_name === 'wtg') {
        return '#f5f5f5'
      } else if (task.task_status_short_name === 'ip') {
        return '#3273dc'
      } else if (task.task_status_short_name === 'pndng') {
        return '#ab26ff'
      } else if (task.task_status_short_name === 'fin') {
        return '#22d160'
      } else if (task.task_status_short_name === 'rtk') {
        return '#ff3860'
      } else if (task.task_status_short_name === 'cfrm') {
        return '#f1c40f'
      } else if (task.task_status_short_name === 'recd') {
        return '#1abc9c'
      }
      return task.task_status_color
    } else {
      return '#ffffff'
    }
  },

  validationRowColor (baseColor, darkTheme) {
    // const darkTheme = localStorage.getItem('dark-theme') === 'true'
    if (darkTheme) {
      return this.darkenColor(baseColor)
    } else {
      return this.lightenColor(baseColor)
    }
  },

  /*
=======
>>>>>>> cdef7a83b4042eb329571c3271a732667afa17d0
   * Turn hexadecimal color (#FFFFFF) to a RGBa one (rgba(255, 255, 255, 0.3))
   */
  hexToRGBa (hex, alpha) {
    const ret = this.hexToRGBLessShit(hex)

    if (alpha) {
      return 'rgba(' + ret.r + ', ' + ret.g + ', ' + ret.b + ', ' + alpha + ')'
    } else {
      return 'rgb(' + ret.r + ', ' + ret.g + ', ' + ret.b + ')'
    }
  },

  hexToRGBLessShit (hex) {
    const rNum = parseInt(hex.slice(1, 3), 16)
    const gNum = parseInt(hex.slice(3, 5), 16)
    const bNum = parseInt(hex.slice(5, 7), 16)

    return {
      r: rNum,
      g: gNum,
      b: bNum
    }
  },

  /*
   * Turn hexadecimal color (#FFFFFF) to a lighter version.
   * Uses a cache for to not recompute the target color each time this function
   * is called.
   */
  lightenColor(colorHash, level = 0.3) {
    if (!lightenColorIndex[colorHash + level]) {
      lightenColorIndex[colorHash + level] = Color(colorHash).lighten(level)
    }
    return lightenColorIndex[colorHash + level]
  },

  /*
   * Turn hexadecimal color (#FFFFFF) to a less saturated version.
   * Uses a cache for to not recompute the target color each time this function
   * is called.
   */
  fadeColor(colorHash, level = 0.3) {
    if (!fadeColorIndex[colorHash + level]) {
      fadeColorIndex[colorHash + level] = Color(colorHash).fade(level)
    }
    return fadeColorIndex[colorHash + level]
  },

  /*
   * Quick and dirty function to change the text color in case the status color
   * is too dark.
   */
  validationTextColor(task) {
    if (
      task &&
      task.task_status_short_name !== 'todo' &&
      task.task_status_short_name !== 'wtg'
    ) {
      return 'white'
    } else {
      return '#333'
    }
  }
}
